<template>
  <div class="settings-page d-flex flex-column">
    <PageHeader title="View API Key" back-button-link="/settings/api" />
    <div
      class="settings-page__body d-flex flex-column align-items-center i-px-12 i-py-11"
    >
      <div class="d-flex justify-content-center w-100">
        <div class="settings-page-view">
          <div
            v-if="hasEditPermissions"
            class="view-form d-flex flex-column i-gap-9"
          >
            <i-text-input
              label="Name"
              :model-value="currentKey.name"
              :disabled="true"
            ></i-text-input>

            <i-text-input
              label="Description (optional)"
              :model-value="currentKey.description"
              :disabled="true"
              :mode="iTextInputModes.TEXTAREA"
            ></i-text-input>

            <div class="d-flex i-mt-6">
              <i-button
                text="Back"
                size="lg"
                type="neutral"
                subtype="subtle"
                @button-click="back()"
              ></i-button>
            </div>
          </div>

          <div v-else class="i-mt-12">
            <p>You must be an administrator to view this API key</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { iButton, iTextInput, iTextInputModes } from '@inscribe/signal';
import PageHeader from '@/V2/components/PageHeader.vue';

export default {
  components: {
    PageHeader,
    iButton,
    iTextInput,
  },
  data() {
    return {
      iTextInputModes,
      apiKey: '',
      currentKey: {},
    };
  },
  computed: {
    ...mapGetters({
      hasEditPermissions: 'isOrgAdmin',
    }),

    ...mapState(['currentUser']),
  },
  mounted() {
    this.apiKey = this.$route.params.api_key;
    this.currentKey = this.currentUser.organisation.api_keys.filter(
      (key) => key.key === this.apiKey,
    )[0];
  },
  methods: {
    back() {
      this.$router.push({
        name: 'api-settings-list-keys',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.view-form {
  max-width: 500px;
}
</style>
